import auth_axios from 'src/service/axios_base/auth_axios'
import Helper from 'src/support/Helper'

const MAX_REQUESTS_COUNT = 10
const INTERVAL_MS = 10
let PENDING_REQUESTS = 0

// create new axios instance
const axios_c_low = auth_axios.create({})

/**
 * Axios Request Interceptor
 */
axios_c_low.interceptors.request.use(function (config) {
    /**
     * CR        : 10107
     * Change    : Remove Extra Header when UAT5 End-points trigger for Auto Suggest & Tabs
     * Change By : Pankaj
     * Date      : 14 April 2023
     */
    
    return new Promise((resolve, reject) => {
        if(config.url.includes(Helper.getAutosuggestUrl()) && config.headers)
        {
            if(config.headers.common['Ocp-Apim-Subscription-Key'])
            {
                delete config.headers.common['Ocp-Apim-Subscription-Key']
            }
            if(config.headers.common['Authorization'])
            {
                delete config.headers.common['Authorization']
            }
            if(config.headers.common['avUserInfo'])
            {
                delete config.headers.common['avUserInfo']
            }
        }

        let interval = setInterval(() => {
            if (PENDING_REQUESTS < MAX_REQUESTS_COUNT) {
                PENDING_REQUESTS++
                clearInterval(interval)
                resolve(config)
            }
        }, INTERVAL_MS)
    })
});

/**
 * Axios Response Interceptor
 */
axios_c_low.interceptors.response.use(function (response) {
    PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
    return Promise.resolve(response)
}, function (error) {
    PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
    return Promise.reject(error)
});

export default axios_c_low